var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M16 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8 5a7 7 0 0 0 0 14h8a7 7 0 1 0 0-14H8zm-5 7a5 5 0 0 1 5-5h8a5 5 0 0 1 0 10H8a5 5 0 0 1-5-5z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }